import { useMemo } from 'react';
import { useClientAssociatedProfilesQuery } from '../../../api/useClientAssociatedProfilesQuery';
import { selectIsUserThirdParty } from '../../../../CommonSelectors/CommonAreaSelector';

export const useClientAssociatedProfiles = ({
  clientId,
  isOrionClient,
}: {
  clientId: string;
  isOrionClient: boolean;
}) => {
  const queryInfo = useClientAssociatedProfilesQuery({
    clientId,
    enabled: isOrionClient || selectIsUserThirdParty(),
  });

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    return queryInfo.data.map(household => ({
      text: household.Name,
      id: household.Id,
      selected: household.Selected,
    }));
  }, [queryInfo.data]);

  return {
    ...queryInfo,
    data,
  };
};
